import { useCallback, useState } from 'react';

export type PaginationState = {
  page: number;
  limit: number;
};

/** Page state for a list view, resetting to page 1 whenever filters change. */
export function usePagination(initialLimit = 25) {
  const [state, setState] = useState<PaginationState>({ page: 1, limit: initialLimit });

  const setPage = useCallback((page: number) => setState((s) => ({ ...s, page })), []);
  const setLimit = useCallback((limit: number) => setState({ page: 1, limit }), []);
  const reset = useCallback(() => setState((s) => ({ ...s, page: 1 })), []);

  return { ...state, setPage, setLimit, reset };
}
